export const toastClassesByType = {
  background: {
    closeButton: '',
    actionButton: '',
  },

  error: {
    closeButton:
      'text-destructive hover:text-destructive-light/70 focus:ring-destructive focus:ring-offset-destructive',
    actionButton:
      'border hover:border-destructive hover:bg-destructive hover:text-destructive-foreground focus:ring-destructive',
  },

  success: {
    closeButton:
      'text-success hover:text-success-light focus:ring-success-dark focus:ring-offset-success-dark',
    actionButton:
      'border hover:border-success hover:bg-success hover:text-success-foreground focus:ring-success',
  },

  info: {
    closeButton: 'text-info hover:text-info-light focus:ring-info-dark focus:ring-offset-info-dark',
    actionButton:
      'border hover:border-info hover:bg-info hover:text-info-foreground focus:ring-info',
  },

  warning: {
    closeButton:
      'text-warning hover:text-warning-light focus:ring-warning-dark focus:ring-offset-warning-dark',
    actionButton:
      'border hover:border-warning hover:bg-warning hover:text-warning-foreground focus:ring-warning',
  },

  primary: {
    closeButton:
      'text-primary hover:text-primary-light focus:ring-primary focus:ring-offset-primary',
    actionButton:
      'border hover:border-primary hover:bg-primary hover:text-primary-foreground focus:ring-primary',
  },
};
